export const PROVISIONAL_RANKED_GAMES = 10

const LEADERBOARD_TAB_STORAGE_KEY = "bitbeast.leaderboard.tab"

export type LeaderboardTab = "solo" | "versus"
export type LobbyQueueType = "quickmatch" | "custom"
export type RankedTier =
  | "Regular"
  | "Silver"
  | "Gold"
  | "Diamond"

export interface RankedLeaderboardEntry {
  userId: string;
  displayName: string;
  rating: number;
  rankedWins: number;
  rankedLosses: number;
  rankedDisconnects: number;
  rankedGames: number;
  rankedPeakRating: number;
  level: number;
  rank: number;
  provisional: boolean;
  tier: RankedTier;
}

export interface RankedPlayerSummary {
  userId: string;
  displayName: string;
  rating: number;
  rankedWins: number;
  rankedLosses: number;
  rankedDisconnects: number;
  rankedGames: number;
  rankedPeakRating: number;
  level: number;
  provisional: boolean;
  rank: number | null;
  percentile: number | null;
  tier: RankedTier;
}

export interface RankedRankContext {
  player: RankedPlayerSummary | null;
  totalEligiblePlayers: number;
  neighbors: RankedLeaderboardEntry[];
}

export function isProvisionalRankedPlayer(rankedGames: number): boolean {
  return Math.max(0, Math.floor(rankedGames)) < PROVISIONAL_RANKED_GAMES
}

export function rankedTierForRating(rating: number): RankedTier {
  const normalizedRating = Math.max(0, Math.floor(rating))
  if (normalizedRating >= 750) return "Diamond"
  if (normalizedRating >= 500) return "Gold"
  if (normalizedRating >= 250) return "Silver"
  return "Regular"
}

export function percentileForRank(rank: number | null, totalEligiblePlayers: number): number | null {
  if (rank == null || totalEligiblePlayers <= 0) {
    return null
  }
  if (totalEligiblePlayers === 1) {
    return 100
  }
  const clampedRank = Math.min(totalEligiblePlayers, Math.max(1, Math.floor(rank)))
  const percentile = ((totalEligiblePlayers - clampedRank) / (totalEligiblePlayers - 1)) * 100
  return Math.max(0, Math.min(100, Math.round(percentile)))
}

export function parseLeaderboardTabPreference(raw: string | null | undefined): LeaderboardTab {
  return raw === "versus" ? "versus" : "solo"
}

export function loadLeaderboardTabPreference(): LeaderboardTab {
  try {
    return parseLeaderboardTabPreference(localStorage.getItem(LEADERBOARD_TAB_STORAGE_KEY))
  } catch {
    return "solo"
  }
}

export function saveLeaderboardTabPreference(tab: LeaderboardTab): void {
  try {
    localStorage.setItem(LEADERBOARD_TAB_STORAGE_KEY, tab)
  } catch {
    // Ignore storage failures.
  }
}
